import { isNonNullish, memoize } from '@epicuro-next/utilities';
import { createFeatureSelector, createSelector } from '@ngrx/store';

import { USER_ENTITIES_STATE_KEY } from './constants';
import { UserEntitiesState } from './user-entities.adapter';

export const selectUserEntitiesState = createFeatureSelector<UserEntitiesState>(
  USER_ENTITIES_STATE_KEY,
);

export const selectUsersFactory = memoize((externalIds: string[]) =>
  createSelector(selectUserEntitiesState, (state) =>
    externalIds.map((id) => state.entities[id]).filter(isNonNullish),
  ),
);

/**
 * Selects users if it was fetched any time or finished loading
 */
export const selectLoadedUsersFactory = memoize((externalIds: string[]) =>
  createSelector(selectUserEntitiesState, (state) => {
    const entities = externalIds.map((id) => state.entities[id]);
    return entities.filter((entity) => !!entity?.user || !entity?.loading);
  }),
);

export const selectUserEntity = (externalId: string) =>
  createSelector(selectUserEntitiesState, (users) => {
    return users.entities[externalId];
  });
